module.exports = __webpack_public_path__ + "media/images/icons/paypal-8ef35d0fbd3ef8fad90731e7ede040dc.svg";